import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Laboratory } from 'src/app/_models/laboratory';
import { FormatRolePipe } from 'src/app/_helpers/format-role.pipe';
import { MatIconButtonComponent } from '../../buttons/mat-icon-button/mat-icon-button.component';
import { StatusIndicatorComponent } from "../../chips/status-indicator/status-indicator.component";

@Component({
  selector: 'app-lab-card',
  imports: [MatIcon, MatIconButtonComponent, FormatRolePipe, StatusIndicatorComponent],
  templateUrl: './lab-card.component.html',
  styleUrl: './lab-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LabCardComponent {
  lab = input.required<Laboratory>();
  role = input<string>('');
  readonly = input<boolean>(false);

  removeClicked = output<Laboratory>();

  onRemove(): void {
    this.removeClicked.emit(this.lab());
  }
}
